import { render, staticRenderFns } from "./clean-eating-a45.vue?vue&type=template&id=899985a8"
import script from "./clean-eating-a45.vue?vue&type=script&lang=js"
export * from "./clean-eating-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports